import { z } from 'zod/v4';

import { PcbCapabilityNameRuntype } from './pcbCapabilityBackendTypes';

export type UnitSystemDTO = z.infer<typeof UnitSystemEnum>;
export const UnitSystemEnum = z.enum(['metric', 'imperial']);

export type PCBSpecificationTemplateDTO = z.infer<typeof PCBSpecificationTemplateRuntype>;
export const PCBSpecificationTemplateRuntype = z.object({
    id: z.string(),
    name: z.string(),
    unit: UnitSystemEnum,
    updated_at: z.iso.datetime().optional(),
    created_at: z.iso.datetime().optional(),
    is_default: z.boolean(),
    required_fields: z.array(PcbCapabilityNameRuntype),
    excluded_fields: z.array(PcbCapabilityNameRuntype),
    customers: z.array(z.string()),
});

export type PCBSpecificationTemplatePostDTO = z.infer<typeof PCBSpecificationTemplatePostRuntype>;
export const PCBSpecificationTemplatePostRuntype = PCBSpecificationTemplateRuntype.omit({
    id: true,
    updated_at: true,
    created_at: true,
});

export type PCBSpecificationTemplatePreferencesDTO = z.infer<typeof PCBSpecificationTemplatePreferencesRuntype>;
export const PCBSpecificationTemplatePreferencesRuntype = z.object({
    pcb: z.string(),
    specification_template: z.string().nullable(),
    visible_fields: z.array(PcbCapabilityNameRuntype),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});

export type PCBSpecificationTemplatePreferencesPostDTO = z.infer<typeof PCBSpecificationTemplatePreferencesPostRuntype>;
export const PCBSpecificationTemplatePreferencesPostRuntype = z.object({
    pcb: z.string().optional(),
    specification_template: z.string(),
    visible_fields: z.array(PcbCapabilityNameRuntype).optional(),
});
